import { Helmet } from 'react-helmet';

export default function Privacy() {
    return (
        <>
            <Helmet>
                <title>Privacy Policy | WebUtility.online</title>
                <meta
                    name="description"
                    content="Read WebUtility.online's Privacy Policy to learn how we collect, use, and protect your data. We value your privacy and are committed to transparency."
                />
                <link rel="canonical" href="https://webutility.online/privacy" />
            </Helmet>

            <section className="p-8 max-w-screen-2xl bg-white rounded-xl shadow-lg mb-4 mx-auto text-center">
                <div className="container mx-auto">
                    <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
                    <p className="mb-4">Last Updated: 2025</p>

                    <p className="mb-4">
                        Welcome to <strong>WebUtility.online</strong> ("we," "our," or "us"). We respect your privacy and are committed to protecting it through this Privacy Policy.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
                    <ul className="list-disc list-inside mb-4 text-center">
                        <li><strong>Non-Personal Data:</strong> We collect usage data such as IP address, browser type, and pages visited for analytics and site improvement.</li>
                        <li><strong>Personal Data:</strong> If you contact us, we may collect your name and email.</li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
                    <ul className="list-disc list-inside mb-4 text-center">
                        <li>To improve our services and user experience.</li>
                        <li>To respond to inquiries or feedback.</li>
                        <li>To display relevant advertisements via Google AdSense.</li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6 mb-2">3. Cookies and Third-Party Services</h2>
                    <p className="mb-4">We use cookies to enhance user experience and serve relevant ads. Third-party services like Google AdSense may collect data according to their own policies.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Protection</h2>
                    <p className="mb-4">We do not sell, trade, or rent your personal information. We take reasonable security measures to protect user data.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
                    <p className="mb-4">
                        You can disable cookies through your browser settings. You can contact us at <a href="mailto:Rp7098979@gmail.com" className="text-blue-600 underline">Rp7098979@gmail.com</a> to request data deletion.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">6. Third-Party Links</h2>
                    <p className="mb-4">Our website may contain links to third-party websites. We are not responsible for their content or privacy practices.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">7. Updates to This Policy</h2>
                    <p className="mb-4">We may update this Privacy Policy from time to time. Please check this page periodically.</p>

                    <p>For questions, contact us at <a href="mailto:Rp7098979@gmail.com" className="text-blue-600 underline">Rp7098979@gmail.com</a>.</p>
                </div>
            </section>
        </>
    );
}
